import { z } from 'zod';
export const Auth0PrefixEnum = z.enum(['auth0', 'google-apps', 'waad', 'email', 'sms']);
